const FlechaDerecha = () => {
  return (
    <svg
      width="34"
      height="24"
      viewBox="0 0 34 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.625"
        y="6.25586"
        width="21.7688"
        height="11.4286"
        rx="2"
        fill="white"
      />
      <path
        d="M32.3244 10.3889C33.3586 11.1896 33.3586 12.7512 32.3244 13.5519L19.6323 23.3777C18.318 24.3953 16.408 23.4585 16.408 21.7963L16.408 2.14454C16.408 0.482329 18.318 -0.454467 19.6323 0.563077L32.3244 10.3889Z"
        fill="white"
      />
    </svg>
  );
};

export default FlechaDerecha;
